"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const ink = {
  "000": "#f8f8f7",
  "100": "#f3f2f2",
  "200": "#ebebeb",
  "300": "#d6d6d6",
  "400": "#c3c4c5",
  "500": "#a1a2a5",
  "600": "#797b81",
  "700": "#52555d",
  "800": "#32353f",
  "900": "#212530"
};

const blue = {
  "000": "#cee1f6",
  "100": "#b5d1f2",
  "200": "#9dc2ed",
  "300": "#84b3e9",
  "400": "#6ba4e4",
  "500": "#5395e0",
  "600": "#3a85db",
  "700": "#0967d2",
  "800": "#085dbd",
  "900": "#0752a8"
};

const green = {
  "000": "#688d68",
  "100": "#5f815f",
  "200": "#577557",
  "300": "#4e6a4e",
  "400": "#455e45",
  "500": "#3d523d",
  "600": "#344734",
  "700": "#2b3b2b",
  "800": "#232f23",
  "900": "#1a231a"
};

const red = {
  "000": "#ffc6ca",
  "100": "#ffb3b8",
  "200": "#ffa0a7",
  "300": "#ff8d95",
  "400": "#ff7a83",
  "500": "#ff6771",
  "600": "#ff5460",
  "700": "#ff414e",
  "800": "#e63b46",
  "900": "#cc343e"
};

const orange = {
  "000": "#ffdcbf",
  "100": "#ffd0a9",
  "200": "#ffc494",
  "300": "#f6c479",
  "400": "#f4bc66",
  "500": "#f3b353",
  "600": "#F1A637",
  "700": "#f0a22d",
  "800": "#ef9a1a",
  "900": "#ff9900"
};

exports.default = {
  white: {
    normal: "#fff"
  },
  ink: _extends({}, ink, {
    lighter: ink["300"],
    lighterHover: ink["400"], // unused in samba-ui
    lighterActive: ink["500"], // unused in samba-ui
    light: ink["700"],
    lightHover: ink["700"], // unused in samba-ui
    lightActive: ink["700"], // unused in samba-ui
    normal: ink["900"],
    normalHover: ink["900"], // unused in samba-ui
    normalActive: ink["900"], // unused in samba-ui
    dark: ink["900"]
  }),
  blue: _extends({}, blue, {
    light: blue["000"],
    lightHover: blue["100"],
    lightActive: blue["200"],
    normal: blue["600"],
    normalHover: blue["700"],
    normalActive: blue["800"],
    dark: blue["900"]
  }),
  green: _extends({}, green, {
    light: green["000"],
    lightHover: green["100"],
    lightActive: green["200"],
    normal: green["700"],
    normalHover: green["800"],
    normalActive: green["900"],
    dark: green["900"]
  }),
  red: _extends({}, red, {
    light: red["000"],
    lightHover: red["100"],
    lightActive: red["200"],
    normal: red["700"],
    normalHover: red["800"],
    normalActive: red["900"],
    dark: red["900"]
  }),
  orange: _extends({}, orange, {
    light: orange["000"],
    lightHover: orange["100"],
    lightActive: orange["200"],
    normal: orange["600"],
    normalHover: orange["700"],
    normalActive: orange["800"],
    dark: orange["900"]
  })
};